export default "__VITE_ASSET__BWsQWxZP__"